import { memberApi } from '../api';

export const openFile = async (fileRecordId: number) => {
  // Open the window first and assign the URL later. If we wait for the presigned URL is fetched to open the URL, Safari
  // will treat it as a window pop-up and block it silently.
  // https://stackoverflow.com/questions/20696041/window-openurl-blank-not-working-on-imac-safari
  const windowRef = window.open();
  const { presignedUrl } = await memberApi.getFile({
    fileRecordId,
  });
  windowRef?.location.assign(presignedUrl);
};
